export default __webpack_public_path__ + "static/media/36I-102743_-15821_0.4d9b3578.jpg";